import type { IconData } from '@stacksjs/iconify-core'

export const coffeeMugSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M25 1a2 2 0 0 0-2 2v7a2 2 0 1 0 4 0V3a2 2 0 0 0-2-2M12.82 46.27c1.923.138 4.288.23 7.18.23s5.257-.091 7.18-.23c4.721-.338 8.04-3.483 8.978-7.77h1.474c3.805 0 7.496-2.652 7.782-6.922a39 39 0 0 0 0-5.156c-.286-4.27-3.977-6.922-7.782-6.922h-1.638c-.385-1.73-1.739-3.06-3.577-3.332C30.292 15.853 26.47 15.5 20 15.5s-10.292.353-12.417.668c-2.023.3-3.46 1.88-3.664 3.866C3.718 21.988 3.5 25.396 3.5 31c0 2.091.03 3.863.079 5.359c.173 5.349 3.764 9.52 9.24 9.912M36.38 24.5c.072 1.737.12 3.878.12 6.5q0 1.334-.015 2.5h1.147c1.66 0 2.714-1.072 2.793-2.256a34 34 0 0 0 0-4.488c-.079-1.183-1.132-2.256-2.793-2.256zM15 5a2 2 0 1 1 4 0v7a2 2 0 1 1-4 0z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default coffeeMugSolid
